<template>
    <div class="screenConfig app-container">
        <div class="screenConfig-edit-header bg-white">
            <span>{{$route.query.name}}</span>
            <span>FID：{{$route.query.fid}}</span>
        </div>
        <el-card class="creenConfig-edit-upload" :body-style="{ padding: '20px' }">
            <animation-upload @uploadSuccess="uploadSuccess" :title="$t('org.powerOn')"/>
            <animation-upload @uploadSuccess="uploadSuccess" :title="$t('org.standby')"/>
            <animation-upload @uploadSuccess="uploadSuccess" :title="$t('org.powerOff')"/>
        </el-card>
        
        <div class="screenConfig-edit-save">
            <el-button type="primary" @click="save">{{$t('commonMsg.save')}}</el-button>
        </div>
    </div>
</template>

<script>
import animationUpload from '@/components/animationUpload'
export default {
    components: {
        animationUpload
    },
    data() {
        return {
            params: {}
        }
    },
    methods: {
        uploadSuccess(obj) {
            this.params = Object.assign(this.params, obj)
        },

        save() {
            if(!Object.keys(this.params).length) {
                this.elMsg(this.$t('alertMsg.uploadTip'), 'warning')
                return;
            };
            this.params.org_id = this.$route.query.id
            this.$http.editScreen(this.params)
                .then(res => {
                    this.elMsg(this.$t('alertMsg.saveSuccess'), 'success')
                    this.$router.back()
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.screenConfig-edit-header{
        padding:10px 20px;
        >span{
            display: inline-block;
            margin-right:10px;
        }
}
.creenConfig-edit-upload{
    margin:20px;
}

.screenConfig-edit-save{
    text-align: center;
    .el-button {
        width:140px;
    }
}
</style>
